import { useEffect } from 'react';
const useClickOutsideObserver = (ref, onClickOutside) => {
    useEffect(() => {
        const handleOutsideEvent = (event) => {
            if (ref.current &&
                event.target instanceof Node &&
                !ref.current.contains(event.target)) {
                onClickOutside(ref);
            }
        };
        document.addEventListener('mousedown', handleOutsideEvent);
        document.addEventListener('keydown', handleOutsideEvent);
        return () => {
            document.removeEventListener('mousedown', handleOutsideEvent);
            document.removeEventListener('keydown', handleOutsideEvent);
        };
    }, [onClickOutside, ref]);
};
export { useClickOutsideObserver };
